import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    standards: [
      { name: 'ISO 9001:2015', href: '/certification/iso-9001' },
      { name: 'ISO/IEC 20000-1:2018', href: '/certification/iso-20000-1' },
      { name: 'ISO/IEC 27001:2022', href: '/certification/iso-27001' },
      { name: 'ISO/IEC 42001:2023', href: '/certification/iso-42001' }
    ],
    services: [
      { name: 'Certification', href: '/certification' },
      { name: 'Certification Process', href: '/certification/process' },
      { name: 'Public Certification Information', href: '/certification/public-information' },
      { name: 'Industries', href: '/industries' },
      { name: 'Resources', href: '/resources' }
    ],
    company: [
      { name: 'About Us', href: '/about' },
      { name: 'Contact Us', href: '/contact' },
      { name: 'Global Offices', href: '/about#offices' },
      { name: 'Careers', href: '/about#careers' }
    ]
  };

  return (
    <footer className="bg-[#003f6d] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4 footer-logo-container">
              <img
                src="/qsc-logo.png"
                alt="QSC America"
                className="footer-logo"
              />
              <div>
                <h3 className="text-xl font-bold">QSC America</h3>
                <p className="text-xs text-gray-300">Quality Standards Certification</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Your trusted partner in ISO certification, helping organizations achieve excellence through internationally recognized standards.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-gray-300">5500 Cherokee Ave. Ste 100, Alexandria, VA 22312</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="text-gray-300">(251) 654 7929</span>
              </div>
            </div>
          </div>

          {/* Featured Standards */}
          <div>
            <h4 className="text-lg font-semibold mb-4">ISO Standards</h4>
            <ul className="space-y-2">
              {footerLinks.standards.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-white transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-center md:text-left">
              <p className="text-gray-300 text-sm">
                © {new Date().getFullYear()} Quality Standards Certification America, LLC. All rights reserved.
              </p>
              <p className="text-gray-400 text-xs mt-1">
                IAS accreditation assessment in progress. Certifications issued under QSC America's independent authority.
              </p>
            </div>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-300 hover:text-white transition-colors duration-200">
                Terms of Service
              </Link>
              <Link to="/certification/public-information" className="text-gray-300 hover:text-white transition-colors duration-200">
                Public Information
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
